import { jsxs as T, jsx as c, Fragment as ue } from "react/jsx-runtime";
import { forwardRef as ce, useState as Q, useEffect as B, useCallback as M, useImperativeHandle as fe } from "react";
import g from "./styles.module.less.js";
import { QuestionType as f } from "@law-connect/types";
import { QuestionWrapper as me } from "../question-wrapper/index.js";
import { ProgressBar as he } from "../progress-bar/index.js";
import { isValidPhoneNumber as we } from "react-phone-number-input";
const pe = ce(
  (y, ie) => {
    var _, G, J, K, X, Y, ee, ne;
    const {
      title: te,
      form: R,
      onChange: Z,
      onComplete: v,
      complete: b,
      onFileUpload: $,
      onFileRemove: S,
      files: D,
      onBack: W,
      language: re,
      labels: A,
      hideConditionalQuestions: k,
      finishStep: P,
      finishStepCondition: m,
      getTranslation: d
    } = y, [i, j] = Q(R.questions), [h, U] = Q([]), [q, w] = Q(0), [a, H] = Q(0), [z, p] = Q(), [O, x] = Q(!1), V = ((_ = i[a]) == null ? void 0 : _.type) === f.File && ((J = (G = i[a]) == null ? void 0 : G.answer) == null ? void 0 : J.some((n) => !("id" in n)));
    B(() => {
      const n = i.map((s) => s.type === f.File && D ? {
        ...s,
        answer: [
          ...D,
          ...(s.answer || []).filter(
            (e) => !("id" in e) && !D.some((t) => t.name === e.name)
          )
        ]
      } : s);
      j(n);
    }, [D]), B(() => {
      Z && q > 0 && Z(i);
    }, [q]), B(() => {
      b && (w(100), x(!0));
    }, [b]);
    const I = M(
      (n) => {
        if (n > i.length - 1)
          return null;
        let s = n + 1, e = i[s];
        if (k)
          for (; e != null && e.hideConditionally; )
            s++, e = i[s];
        if (!e)
          return null;
        if (e.onlyAvailableIf) {
          const t = e.onlyAvailableIf, r = (l, u) => {
            for (const N of u) {
              if (N.id === l)
                return N;
              if (N.type === f.MultiPart) {
                const F = r(l, N.questions);
                if (F)
                  return F;
              }
            }
            return null;
          }, o = r(
            t.questionId,
            i
          );
          if (o) {
            if (Array.isArray(t.answer)) {
              if (!t.answer.includes(
                o.answer
              ))
                return I(n + 1);
            } else if (o.answer !== (t == null ? void 0 : t.answer))
              return I(n + 1);
          }
        }
        return e;
      },
      [i]
    ), C = M(
      (n) => {
        if (n && n.type === f.File) {
          const e = i.find((o) => o.id === n.id).answer || [], t = n.answer || [], r = [];
          e.forEach((o) => {
            "id" in o && (t.filter((l) => "id" in l).some((l) => o.id === l.id) || (S && S(o), r.push(o)));
          }), r.length > 0 && (n.answer = [...n.answer || [], ...r]);
        }
        j((s) => {
          const e = s.findIndex((r) => r.id === n.id), t = [...s];
          return t[e] = { ...n, answeredAt: Date.now() }, t;
        }), p("");
      },
      [S, i]
    ), E = M(
      (n, s) => {
        n && n.preventDefault();
        const e = { ...i[a] };
        if (s && (e.answer = void 0, e.answeredAt = Date.now()), e && e.required && (e.answer === void 0 || e.answer === "" || e.answer === null)) {
          p(d("toast.answer-question"));
          return;
        } else if (e.type === f.SplitDate && e.answer && (e.answer.year === "" || e.answer.year === void 0 || e.answer === null)) {
          p(d("toast.answer-question"));
          return;
        } else if (e.type === f.Email) {
          if (e.answer && !e.answer.match(
            // eslint-disable-next-line no-useless-escape
            /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
          )) {
            p(d("toast.invalid-email"));
            return;
          }
        } else if (e.type === f.Phone && e.answer && !we(e.answer)) {
          p(d("toast.invalid-phone-number"));
          return;
        }
        const t = I(a);
        if (t) {
          C({ ...e, answeredAt: Date.now() }), U([...h, e.id]), p("");
          const r = i.findIndex(
            (o) => o.id === t.id
          );
          if (H(r), k) {
            const o = i.filter(
              (u) => !u.hideConditionally
            ), l = o.findIndex(
              (u) => u.id === t.id
            );
            w(
              l / o.length * 100
            );
          } else
            w(r / i.length * 100);
          x(!1);
        } else {
          const r = {
            ...e,
            answeredAt: Date.now()
          };
          C(r), U([...h, e.id]), p("");
          const l = i.filter(
            (u) => u.type !== f.File
          ).map((u) => u.id == e.id ? r : u);
          if (P && m && (Array.isArray(m) ? m : [m]).some((F) => {
            const L = i.find((de) => de.id === F.questionId);
            return (L == null ? void 0 : L.answer) === F.value;
          })) {
            y != null && y.onChange && y.onChange(l), P().then((F) => {
              F && (v && v(l), w(100), x(!0));
            });
            return;
          }
          v && v(l), w(100), x(!0);
        }
      },
      [
        i,
        a,
        I,
        d,
        C,
        h,
        k,
        v
      ]
    ), se = (n) => {
      n.preventDefault(), E(n, !0);
    }, oe = (n) => {
      n && n.preventDefault(), O && x(!1);
      const s = h[h.length - 1], e = i.find(
        (t) => t.id === s
      );
      if (e) {
        const t = i.findIndex(
          (r) => r.id === e.id
        );
        if (U(h.slice(0, h.length - 1)), H(t), k) {
          const r = i.filter(
            (l) => !l.hideConditionally
          ), o = r.findIndex(
            (l) => l.id === e.id
          );
          w(
            o / r.length * 100
          );
        } else
          w(t / i.length * 100);
        p("");
      }
    }, ae = (n) => (s) => {
      if (s.preventDefault(), n.type === f.File && n.answer) {
        const e = n.answer.filter(
          (t) => !("id" in t)
        );
        if (e.length > 0) {
          const t = n.answer.map((r) => ("id" in r || (r.uploading = !0), r));
          C({
            ...n,
            answer: t,
            answeredAt: Date.now()
          }), $ && $(e);
        }
      }
    };
    fe(ie, () => ({
      finish: () => {
        v && v(i), w(100), x(!0);
      }
    })), B(() => {
      const n = (s) => {
        !b && s.key === "Enter" && (s.preventDefault(), s.stopPropagation(), E());
      };
      return window.addEventListener("keydown", n), () => {
        window.removeEventListener("keydown", n);
      };
    }, [b, E]);
    const le = M(() => P && m ? !(Array.isArray(m) ? m : [m]).some((e) => {
      const t = i.find((r) => r.id === e.questionId);
      return (t == null ? void 0 : t.answer) === e.value;
    }) : !0, [P, m, i]);
    return /* @__PURE__ */ T(
      "form",
      {
        ...y.props,
        className: `${g.inlineForm} ${(K = y.props) == null ? void 0 : K.className}`,
        onSubmit: (n) => {
          n.preventDefault();
        },
        children: [
          /* @__PURE__ */ c("div", { className: g.inlineFormTitle, children: te || R.name }),
          /* @__PURE__ */ c("div", { className: g.inlineFormProgressBar, children: /* @__PURE__ */ c(he, { value: q }) }),
          O ? null : /* @__PURE__ */ T(ue, { children: [
            /* @__PURE__ */ c("div", { className: g.inlineFormQuestionWrapper, children: i && i[a] ? /* @__PURE__ */ c(
              me,
              {
                questions: i,
                question: i[a],
                onChange: C,
                language: re,
                getTranslation: d
              },
              i[a].id
            ) : null }),
            z ? /* @__PURE__ */ c("div", { className: g.inlineFormError, children: z }) : null,
            /* @__PURE__ */ T("div", { className: g.formFooter, children: [
              /* @__PURE__ */ c("div", { className: g.formFooterLeft, children: a > 0 || W ? /* @__PURE__ */ c(
                "button",
                {
                  onClick: a > 0 ? oe : W,
                  disabled: h.length === 0 && !W,
                  children: d("chat.back")
                }
              ) : null }),
              /* @__PURE__ */ T("div", { className: g.formFooterRight, children: [
                ((X = i[a]) == null ? void 0 : X.type) === f.File ? /* @__PURE__ */ c(
                  "button",
                  {
                    onClick: ae(i[a]),
                    disabled: !V || !((Y = i[a].answer) != null && Y.filter((n) => !("id" in n)).length) || ((ee = i[a].answer) == null ? void 0 : ee.filter(
                      (n) => !("id" in n) && n.uploading
                    ).length) > 0,
                    children: d("prematter.upload")
                  }
                ) : !((ne = i[a]) != null && ne.required) && I(a) ? /* @__PURE__ */ c("button", { onClick: se, children: (A == null ? void 0 : A.optional) || d("chat.dunno") }) : null,
                /* @__PURE__ */ c(
                  "button",
                  {
                    onClick: E,
                    disabled: !!z || V,
                    children: I(a) ? d("chat.next") : le() ? (A == null ? void 0 : A.submit) || d("chat.finish") : d("chat.next")
                  }
                )
              ] })
            ] })
          ] })
        ]
      }
    );
  }
);
pe.displayName = "InlineForm";
export {
  pe as InlineForm
};
